import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { useAuth } from '../context/AuthContext'
import SpinnerCircular from './SpinnerCircular'
import { theme } from '../theme'

/**
 * AdminGuard is a UX layer — it hides admin pages from non-admins. The REAL
 * authorization is enforced by the backend's `requireMotorikAdmin` middleware
 * on every `/api/admin/*` request, driven by the `MOTORIK_ADMIN_EMAILS` and
 * `MOTORIK_ADMIN_USER_IDS` env vars.
 *
 * The frontend learns whether the current user is admin from the
 * `isMotorikAdmin` boolean returned by `GET /api/users/profile`.
 */
const AdminGuard = ({ children }) => {
  const { user, loading, token } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Loader>
        <SpinnerCircular
          size={30}
          thickness={180}
          speed={100}
          color={theme.fill.brandMain}
          secondaryColor={theme.fill.defaultWeak}
        />
      </Loader>
    )
  }

  if (!token || !user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/signin" state={{ returnTo }} replace />
  }

  if (!user.isMotorikAdmin) {
    return <Navigate to="/" replace />
  }

  return children ? children : <Outlet />
}

export default AdminGuard

const Loader = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;
`
